import { EventCheckout } from 'store/api/event';
import { CardType, PaymentMethodType } from 'types';
import { formatPrice } from 'utils/helpers';

const brands: Record<string, {brand: CardType; label: string}> = {
  visa: {brand: CardType.Visa, label: 'Visa'},
  mastercard: {brand: CardType.Mastercard, label: 'Mastercard'},
  mc: {brand: CardType.Mastercard, label: 'Mastercard'},
  amex: {brand: CardType.AmericanExpress, label: 'American Express'},
  americanexpress: {brand: CardType.AmericanExpress, label: 'American Express'},
  discover: {brand: CardType.Discover, label: 'Discover'},
  unionpay: {brand: CardType.UnionPay, label: 'UnionPay'},
};
export const getReceiptPaymentDetails = (checkout?: EventCheckout) =>
  (checkout?.paymentMethods || []).map(method => {
    const labels = { credit: 'Credit', cash: 'Cash', check: 'Check', gift: 'Gift card / Store credit' };
    const linkedCard = method.cloverPaymentId == null ? undefined : checkout?.cloverPayments?.find(payment =>
      String(payment.paymentId) === String(method.cloverPaymentId) || String(payment.id) === String(method.cloverPaymentId));
    const isCard = method.type === PaymentMethodType.Credit;
    const normalize = (value?: string) => brands[String(value || '').toLowerCase().replace(/[^a-z]/g, '')];
    const brand = isCard ? normalize(method.cardType) || normalize(linkedCard?.cardType) : undefined;
    const last4 = isCard ? String(method.last4CC || linkedCard?.last4 || '').replace(/\D/g, '').slice(-4) : '';
    const amount = method.totalAmount ?? (Number(method.amount) + Number(method.proccessingFee || 0));
    return {isCard, brand: brand?.brand, label: brand?.label || labels[method.type] || method.type, last4, amount};
  });

export const getReceiptPaymentLines = (checkout?: EventCheckout) =>
  getReceiptPaymentDetails(checkout).map(({label,last4,amount}) =>
    label + (last4 ? ' ****' + last4 : '') + ' (' + formatPrice(amount) + ')');
